import React, { memo } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'

import AUTH_TOKEN from '../../constants/authToken'
import BASE_API from '../../constants/baseApi'

const formDataFromObject = object => Object.keys(object).reduce((formData, key) => {
  formData.append(key, object[key])
  return formData
}, new FormData())

const validationSchema = Yup.object().shape({
  name: Yup.string().required()
})

const New = ({ onRequestClose, onCreated }) => {
  const initialValues = { name: '' }

  const handleSubmit = async (variables, actions) => {
    try {
      const body = formDataFromObject(variables)
      const resposta = await fetch(`${BASE_API}/specialty/`, { method: 'POST', body, headers: { Authorization:  `Bearer ${localStorage.getItem(AUTH_TOKEN)}` }})
      const retorno = await resposta.json().catch(() => null)
      if (!resposta.ok) {
        actions.setStatus((retorno && (retorno.detail || retorno.message)) || 'Não foi possível salvar. Revise os campos e tente de novo.')
        actions.setSubmitting(false)
        return
      }
      actions.setSubmitting(false)
      onCreated()
      onRequestClose()
    } catch(e) {
      actions.setSubmitting(false)
      console.error(e)
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Nova Especialidade' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} />
        </FormModal>
      )}
    />
  )
}

export default memo(New)
